import { useSelector } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import ActivityEdit from "./pages/ActivityEdit";
import Careers from "./pages/Careers";
import Categories from "./pages/Categories";
import CategoryDetails from "./pages/CategoryDetails";
import CookEdit from "./pages/CookEdit";
import CooksCategories from "./pages/CooksCategories";
import CooksCategoryDetails from "./pages/CooksCategoryDetails";
import CouponDetails from "./pages/CouponDetails";
import CustomerDetails from "./pages/CustomerDetails";
import EmailManagement from "./pages/EmailManagement";
import Home from "./pages/Home";
import JobApplicationInfo from "./pages/JobApplicationInfo";
import JobPositionEdit from "./pages/JobPositionEdit";
import Login from "./pages/Login";
import Messages from "./pages/Messages";
import News from "./pages/News";
import NewsEdit from "./pages/NewsEdit";
import OfferDetails from "./pages/OfferDetails";
import Offers from "./pages/Offers";
import OrderDetails from "./pages/OrderDetails";
import Orders from "./pages/Orders";
import Pages from "./pages/Pages";
import ProductDetails from "./pages/ProductDetails";
import Products from "./pages/Products";
import Settings from "./pages/Settings";
import Users from "./pages/Users";
import { selectUser } from "./redux/slices/userSlice";

function App() {
  const currentUser = useSelector(selectUser);
  const adminRole = currentUser?.user?.[1];
  const routing = [
    {
      allowedRoles:["Admin", "Sales"],
      path: "/orders",
      component: <Orders />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/products",
      component: <Products />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/categories",
      component: <Categories />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/pages",
      component: <Pages />,
    },
    {
      allowedRoles:["Admin"],
      path: "/users",
      component: <Users />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/news",
      component: <News />,
    },
    {
      allowedRoles:["Admin", "Messaging"],
      path: "/messages",
      component: <Messages />,
    },
    {
      allowedRoles:["Admin", "HR"],
      path: "/careers",
      component: <Careers />,
    },
    {
      allowedRoles:["Admin", "Sales"],
      path: "/offers",
      component: <Offers />,
    },
    {
      allowedRoles:["Admin"],
      path: "/settings",
      component: <Settings />,
    },
    {
      allowedRoles: ["DataEntry", "Admin"],
      path: "/category-details",
      component: <CategoryDetails />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/cooks-categories",
      component: <CooksCategories />,
    },
    {
      allowedRoles:["Admin", "DataEntry"],
      path: "/cook-edit",
      component: <CookEdit />,
    },
    {
      allowedRoles: ["DataEntry", "Admin"],
      path: "/cooks-category-details",
      component: <CooksCategoryDetails />,
    },
    {
      allowedRoles: ["DataEntry", "Admin"],
      path: "/product-details",
      component: <ProductDetails />,
    },
    {
      allowedRoles:["Admin"],
      path: "/customer",
      component: <CustomerDetails />,
    },
    {
      allowedRoles: ["DataEntry", "Admin"],
      path: "/activity-edit",
      component: <ActivityEdit />,
    },
    {
      allowedRoles: ["DataEntry", "Admin"],
      path: "/news-edit",
      component: <NewsEdit />,
    },
    {
      allowedRoles: ["HR", "Admin"],
      path: "/job-application-info",
      component: <JobApplicationInfo />,
    },
    {
      allowedRoles: ["HR", "Admin"],
      path: "/job-position-edit",
      component: <JobPositionEdit />,
    },
    {
      allowedRoles: ["Messaging", "Admin"],
      path: "/emails",
      component: <EmailManagement />,
    },
    {
      allowedRoles: ["Sales", "Admin"],
      path: "/order-details",
      component: <OrderDetails />,
    },
    {
      allowedRoles: ["Sales", "Admin"],
      path: "/coupon-details",
      component: <CouponDetails />,
    },
    {
      allowedRoles: ["Sales", "Admin"],
      path: "/offer-details",
      component: <OfferDetails />,
    },
    {
      path: "/",
      component: <Home />,
    },
  ];
  return (
    <BrowserRouter>
      <div>
        <Routes>
          {routing.map((route) => (
            <Route
              path={route.path}
              element={
                (currentUser.isLoggedIn &&
                  route.allowedRoles?.includes(adminRole)) ||
                (!route.allowedRoles && currentUser.isLoggedIn) ? (
                  route.component
                ) : (
                  <Navigate replace to="/login" />
                )
              }
            />
          ))}
          <Route
            path="/login"
            element={
              !currentUser.isLoggedIn ? <Login /> : <Navigate replace to="/" />
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
